import React from 'react';

export default ({ supports }) => (
  <>
    <span className={`supports supports-${supports ? 'yes' : 'no'}`} />
    <span className="sr-only">{supports ? 'Yes' : 'No'}</span>
  </>
);
